<template>
  <div class="category-header">
    <h1 class="category-header__seo-h1">
      {{ categoryInfo.name || categoryInfo.url_key.replace('-', ' ') }}
    </h1>
    <div class="category-header__heading" v-html="categoryInfo.name" />
    <div
      class="category-header__description"
      v-html="categoryInfo.description"
    />
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'CategoryHeader',
  props: {
    categoryInfo: {
      type: Object,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.category-header {
  @include flex-center;
  flex-direction: column;
  gap: 1.25rem;
  padding: 4.0269rem 1.25rem 2.5rem 1.25rem;
  &__heading,
  &__description {
    margin: 0;
    padding: 0;
    text-align: center;
    @include flex-center;
  }
  &__heading {
    @include mobile-h4;
  }
  &__description {
    @include paragraph-l;
  }
  &__seo-h1 {
    display: none;
  }
}
@include from-desktop-min {
  .category-header {
    max-width: 64%;
    margin: 0 auto;
    padding-top: 3.5rem;
    &__heading,
    &__description {
      margin: 0 auto;
    }
    &__heading {
      @include desktop-h4;
    }
  }
}
</style>
